import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import { machineProfile } from "../../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  printLocation,
} from "../../../utils/helper.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import { MachineProfile } from "../../../api/machine_profile.js";
import ConfirmationDlg from "../../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../../components/LocationFilter/index.jsx";
import ImageViewer from "../../../components/ImageViewer";
import { alert } from "./data";
import { QRCode } from "react-qrcode-logo";

function MachineList() {
  const [datas, setDatas] = useState(alert);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const navigate = useNavigate();

  const columns = [
    {
      name: "Asset ID",
      selector: (row) => row["Asset ID"],
      minWidth: "250px",
      maxWidth: "250px",
    },
    {
      name: "Asset Name",
      selector: (row) => row["Asset Name"],
      minWidth: "200px",
      maxWidth: "200px",
    },

    {
      name: "Forecasted Replacement Date",
      selector: (row) => row["Forecasted Replacement Date"],

      minWidth: "200px",
      maxWidth: "250px",
    },
    {
      name: "Forecasted Cost",
      selector: (row) => row["Forecasted Maintenance Cost"],
      minWidth: "200px",
      maxWidth: "250px",
    },
  ];
  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await machineProfile.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };
  const onRowClicked = (row) => {
    navigate(`/machine-asset/asset-replacement-detail/${row["Asset ID"]}`);
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">MACHINE</a>
            </li>
            <li className="breadcrumb-item active">ASSET REPLACEMENT</li>
          </ul>

          <h1 className="page-header">Asset Replacement</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div className="col-sm-3 mb-2 mb-sm-0">
                <LocationFilter onChange={handleChangeLocationFilter} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12" style={{ corsor: "pointer" }}>
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        highlightOnHover
                        style={{ cursor: "pointer" }}
                        theme="dark"
                        columns={columns}
                        onRowClicked={onRowClicked}
                        data={datas}
                        pagination
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
